import { cn } from "~/lib/utils";

interface ChevronRightProps {
  className?: string;
  size?: number;
}

export default function ChevronRight({
  className,
  size = 16,
}: ChevronRightProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("", className)}
    >
      <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
  );
}
